<template>
  <div name="logical-statement-view">
    <template v-if="typeof list.conj !== 'undefined'">
      <div class="conjuction-box clearfix">
        <span class="desc-text">{{ list.descConj }} </span>
        <i class="fa fa-close close-button" @click="deleteList(index)" />
        <template v-if="linkDisp">
          <i v-if="totalLists >= 2" class="fa fa-unlink unlink-button" title="click for link statement" @click="setLinkDisp(index)"/>
          <i v-else class="fa fa-unlink unlink-button -disable" title="required minimum 2 statements for linking" />
        </template>
        <template v-else>
          <i v-if="totalLists >= 2" class="fa fa-link link-button color-skin" title="click for unlink statement" @click="setUnlinkDisp(index)"/>
          <i v-else class="fa fa-link link-button -disable color-skin" title="required minimum 2 statements for unlinking" />
        </template>
        <i class="fa fa-pencil ungroup-button" title="click for edit statement" @click="editList(index)"/>
      </div>
    </template>
    <template v-if="typeof list.conj === 'undefined'">
      <div class="text-box clearfix">
        <span class="desc-text">{{ list.descStmt }}</span>
        <i class="fa fa-close close-button" @click="deleteList(index)" title="click for cancel statement" />
        <template v-if="linkDisp">
          <i v-if="totalLists >= 2" class="fa fa-unlink unlink-button" title="click for link statement" @click="setLinkDisp(index)"/>
          <i v-else class="fa fa-unlink unlink-button -disable" title="required minimum 2 statements for linking" />
        </template>
        <template v-else>
          <i v-if="totalLists >= 2" class="fa fa-link link-button color-skin" title="click for unlink statement" @click="setUnlinkDisp(index)"/>
          <i v-else class="fa fa-link link-button -disable color-skin" title="required minimum 2 statements for unlinking" />
        </template>
        <i v-if="typeof list.statement !== 'undefined'" class="fa fa-object-ungroup ungroup-button" title="click for ungroup statement" @click="ungroupList(index)"/>
        <i v-if="typeof list.statement === 'undefined'" class="fa fa-pencil ungroup-button" title="click for edit statement" @click="editList(index)"/>
      </div>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'logical-statement-view',
    data () {
      return {
        linkDisp: true
      }
    },
    watch: {
      list (newVal) {
        this.linkDisp = true
      }
    },
    methods: {
      setLinkDisp (index) {
        this.linkDisp = false
        this.linkList(index)
      },
      setUnlinkDisp (index) {
        this.linkDisp = true
        this.unlinkList(index)
      }
    },
    props: {
      totalLists: {
        type: Number,
        default: 0
      },
      list: {
        type: Object,
        required: true
      },
      index: {
        type: Number
      },
      linkList: {
        type: Function
      },
      unlinkList: {
        type: Function
      },
      ungroupList: {
        type: Function
      },
      editList: {
        type: Function
      },
      deleteList: {
        type: Function
      }
    }
  }
</script>


// WEBPACK FOOTER //
// listView.vue?3504f872